import InfiniteScroll from "react-infinite-scroll-component";
import { LoaderCircle } from "lucide-react";
import SkeletonMusicLibrariesTable from "pages/account-detail/music-libraries/skeleton/SkeletonMusicLibrariesTable";
import { useDispatch } from "react-redux";

import { noneProfile } from "assets";
import ImageUrl from "components/app/image-url/ImageUrl";
import { Service } from "utils/services";
import { setOpenPopoverIndex } from "store/request";
import { getRequestTypeStyle } from "./getRequestTypeStyle";

const RequestTable = ({
  listRef,
  selectProducts,
  setSelectedProductIds,
  handleClickUrl,
  employeeInitRequestSearch,
  fetchMoreEmployeeRequestSearch,
  employeeRequestSearchLoading,
  getShopEmployeeRequestDetail,
  setIsDetail,
  setWarning2,
  loadingEmployeeInitRequestSearch,
}: any) => {
  const dispatch = useDispatch();
  return (
    <InfiniteScroll
      dataLength={employeeInitRequestSearch?.data?.length || 0}
      next={() =>
        fetchMoreEmployeeRequestSearch({
          next: employeeRequestSearchLoading?.nextPageUrl,
        })
      }
      scrollThreshold="90%"
      hasMore={!!employeeRequestSearchLoading?.nextPageUrl}
      scrollableTarget="scrollableDiv"
      loader={
        <div className="absolute bottom-2 left-0 w-full flex justify-center mt-5">
          <LoaderCircle size={30} className="animate-spin text-yellow-400" />
        </div>
      }
    >
      <>
        {loadingEmployeeInitRequestSearch ? (
          <SkeletonMusicLibrariesTable />
        ) : (
          <table className="min-w-full border-collapse mb-20 rounded-md overflow-hidden">
            <thead className="sticky top-0 left-0 text-xs text-gray-700  bg-gray-300 dark:bg-[#2c3a52] dark:text-gray-400">
              <tr className="border-none  text-[15px]">
                <th className="py-5 text-start  px-4 first:rounded-tl-md last:rounded-tr-md ">Image</th>
                <th className=" px-4 text-start ">Staff Info. </th>
                <th className="text-start  pe-[70px] ps-4">Status</th>
                <th className="text-start px-4">Contact</th>

                <th className="text-start  px-4">Department</th>
                <th className="text-start  px-4">Request </th>
                <th className="text-start  pe-[70px] "> Date</th>
                <th className="text-start  px-4"> Approvers</th>
                <th className="text-start  px-4"> Status</th>
              </tr>
            </thead>
            <tbody ref={listRef}>
              {employeeInitRequestSearch?.data
                ?.filter((item: any, index: number, self: any) => index === self.findIndex((t: any) => t.id === item.id))
                ?.map((item: any, index: number) => {
                  const { text, color } = getRequestTypeStyle(item.request_type, item);

                  return (
                    <tr
                      onClick={() => {
                        if (selectProducts) {
                          setSelectedProductIds((prev: any) => (prev.includes(item.id) ? prev.filter((id: any) => id !== item.id) : [...prev, item.id]));
                          return;
                        } else {
                          if (item.is_deleted === 0) {
                            setIsDetail(true);
                            getShopEmployeeRequestDetail(item.id);
                            setWarning2(false);
                            handleClickUrl(item?.id, "request_id");
                            dispatch(setOpenPopoverIndex(1));
                          }
                        }
                      }}
                      key={index}
                      className={`group text-center cursor-pointer ${index % 2 === 0 ? "bg-gray-100 dark:bg-[#1e293b] " : "bg-gray-200 dark:bg-[#2c3a52] "} hover:bg-gray-300`}
                    >
                      <td className="relative w-[120px] h-[120px] aspect-square overflow-hidden ">
                        {item.is_deleted === 0 ? (
                          ""
                        ) : (
                          <button
                            onClick={(event) => {
                              event.stopPropagation();
                            }}
                            className="font-semibold text-sm z-50 absolute flex items-center justify-center text-white shadow-md shadow-red-500 inset-0 mx-auto top-[40%] cursor-pointer w-[70px] h-8 bg-black/50 rounded-full p-1"
                          >
                            Deleted
                          </button>
                        )}
                        <img
                          className={`w-full  z-1 mx-auto relative h-full ${item.is_deleted === 1 && "opacity-50"}  `}
                          src={!item.requester?.picture ? noneProfile : item.requester?.picture}
                          alt=""
                        />
                      </td>
                      <td className="py-2 px-4 text-md  text-left align-top">
                        <p className="text-[15px] font-bold ">{item.requester?.card_no}</p>

                        <p className="text-[15px] ">{item.requester?.local_name}</p>
                        <p className="text-md text-muted-foreground ">{item.requester?.english_name}</p>
                        <p className="text-md text-muted-foreground ">{item?.requester?.nationality}</p>
                      </td>
                      <td className="py-2 px-4  text-md  text-left align-top text-nowrap">
                        <p className="text-md "> {item?.requester?.gender}</p>
                        <p className="text-md text-muted-foreground"> {item?.requester?.marital_status}</p>
                        <p className="text-md  ">{Service.formatDateTime(item?.requester?.date_of_birth, { format: "ddd, DD-MMM-YYYY" })}</p>
                      </td>
                      <td className="py-2 px-4 text-md  text-left align-top">
                        <p className="text-md "> {item?.requester?.phone_no}</p>
                        <p className="text-md line-clamp-1 text-muted-foreground"> {item?.requester?.email}</p>
                        <p className="text-md text-muted-foreground">{item?.requester?.address}</p>
                      </td>

                      <td className="py-2 px-4 text-md  text-left align-top">
                        <p className="text-md line-clamp-1 "> {item?.department}</p>
                        <p className="text-md text-muted-foreground "> {item?.position}</p>
                      </td>
                      <td className="py-2 px-4  text-left align-top h-[100px] overflow-hidden ">
                        <p className={`font-bold text-[15px] w-full  rounded-md py-1  line-clamp-1 ${color}`}>{text}</p>

                        {/* --------Leave Application Form------ */}
                        {item.request_type === "Leave Application Form" && (
                          <>
                            <p className="text-[15px] font-bold text-red-500">
                              {" "}
                              {item.document?.leave_period === "Full Day"
                                ? `${parseFloat(item.document?.no_of_day)} ${parseFloat(item.document?.no_of_day) === 1 ? "Day" : "Days"}`
                                : `${parseFloat(item.document?.no_of_hour)} ${parseFloat(item.document?.no_of_hour) === 1 ? "Hour" : "Hours"}`}
                            </p>
                          </>
                        )}
                        {/* --------Tardiness Application Form------ */}

                        {item.request_type === "Tardiness Application Form" && (
                          <>
                            {item.document?.missing_type === "Other" ? (
                              <p
                                className="text-md text-muted-foreground line-clamp-3"
                                dangerouslySetInnerHTML={{
                                  __html: item.document?.missing_remark?.replace(/\n/g, "<br />"),
                                }}
                              ></p>
                            ) : (
                              <p className="text-md text-muted-foreground">{item.document?.missing_type}</p>
                            )}
                          </>
                        )}
                        {/* --------Chnage Day Off------ */}

                        {item.request_type === "Change DO Application Form" && (
                          <>
                            <p
                              className="text-md text-muted-foreground line-clamp-3"
                              dangerouslySetInnerHTML={{
                                __html: item.document?.remark?.replace(/\n/g, "<br />"),
                              }}
                            ></p>
                          </>
                        )}
                        {/* --------Leave Application Form------ */}
                        {item.request_type === "Change Shift Application Form" && (
                          <>
                            <p
                              className="text-md text-muted-foreground line-clamp-3 overflow-hidden"
                              dangerouslySetInnerHTML={{
                                __html: item.document?.remark?.replace(/\n/g, "<br />"),
                              }}
                            ></p>
                          </>
                        )}
                      </td>

                      <td className="py-2 text-md  text-left align-top text-nowrap">
                        {/* --------Leave Application Form------ */}
                        {item.request_type === "Leave Application Form" && (
                          <>
                            <>
                              {item?.document?.starting_date && (
                                <p className="text-md text-muted-foreground pt-1  ">{Service.formatDateTime(item?.document?.starting_date, { format: "ddd, DD-MMM-YYYY" })}</p>
                              )}

                              {item.document?.leave_period === "Full Day" ? (
                                <>
                                  {item.document?.no_of_day > 1 && (
                                    <p className="text-md text-muted-foreground pt-1  ">{Service.formatDateTime(item.document?.ending_date, { format: "ddd, DD-MMM-YYYY" })}</p>
                                  )}
                                </>
                              ) : (
                                <div className="flex items-center gap-1 text-muted-foreground">
                                  <p className="text-md text-nowrap text-muted-foreground pt-1"> {Service.formatTime(item.document?.starting_time)}</p>-
                                  <p className="text-md text-nowrap text-muted-foreground pt-1"> {Service.formatTime(item.document?.ending_time)}</p>
                                </div>
                              )}
                            </>
                          </>
                        )}
                        {/* --------Tardiness Application Form------ */}

                        {item.request_type === "Tardiness Application Form" && (
                          <>
                            <p className="text-md font-bold  ">{Service.formatDateTime(item?.document?.working_date, { format: "ddd, DD-MMM-YYYY" })}</p>

                            <p className="text-md text-muted-foreground">
                              {item.document?.missing_period
                                ?.split("|")
                                .map((s: any) => s.trim())
                                .join(", ")}
                            </p>
                          </>
                        )}

                        {/* --------Chnage Day Off------ */}

                        {item.request_type === "Change DO Application Form" && (
                          <>
                            <p className="text-md font-bold  ">{Service.formatDateTime(item?.document?.working_date, { format: "ddd, DD-MMM-YYYY" })}</p>
                          </>
                        )}
                        {/* --------Change Shift Application Form------ */}

                        {item.request_type === "Change Shift Application Form" && (
                          <>
                            <p className="text-md font-bold pt-1 ">{Service.formatDateTime(item?.document?.working_date, { format: "ddd, DD-MMM-YYYY" })}</p>
                            <p className="text-md text-muted-foreground pt-1">{item.document?.to_shift_group?.local_description}</p>
                          </>
                        )}
                      </td>
                      <td className=" text-left align-top ">
                        {item?.approvers.map((approvers: any, index: number) => {
                          return (
                            <div key={index} className="gap-3 flex items-center  rounded-md p-1  w-[180px] ">
                              <ImageUrl
                                src={!approvers?.accept_employee?.picture ? noneProfile : approvers?.accept_employee?.picture}
                                className=" h-[45px] w-[45px] rounded-full"
                                alt={approvers?.accept_employee?.picture}
                              />
                              <div className="flex flex-col text-start ">
                                <span className="w-full font-medium line-clamp-1 leading-none lg:text-md md:text-sm text-[15px]">
                                  {approvers?.accept_employee?.local_name?.length > 12
                                    ? `${approvers?.accept_employee?.local_name.slice(0, 12)}...`
                                    : approvers?.accept_employee?.local_name}
                                </span>
                                <span className="text-sm text-muted-foreground line-clamp-1">
                                  {approvers?.accept_employee?.position?.length > 12
                                    ? `${approvers?.accept_employee?.position.slice(0, 12)}...`
                                    : approvers?.accept_employee?.position}
                                </span>
                              </div>
                            </div>
                          );
                        })}
                      </td>
                      <td className="py-2 px-4 text-md  text-left align-top">
                        <div
                          className={` ${
                            item?.status === "Pending" ? "bg-yellow-500" : item?.status === "Approved" ? "bg-green-500" : "bg-red-500"
                          }  text-white px-3 py-1 rounded-md mt-0 text-center inline-block`}
                        >
                          <span className=" text-sm font-bold ">{item?.status}</span>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              {!employeeInitRequestSearch?.next_page_url ? (
                <p className="absolute bottom-0 left-0 w-full text-center mb-5 flex items-center justify-center">
                  <b>Nothing more to load!</b>
                </p>
              ) : (
                ""
              )}
            </tbody>
          </table>
        )}
      </>
    </InfiniteScroll>
  );
};

export default RequestTable;
